import React, { useEffect, useState } from 'react'
import { styled } from '@mui/system'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';

function Industryview(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const viewId = useParams();
    const industryId = viewId.industryid;

    useEffect(() => {
        const getComments = async () => {
          try{
            const postData = {
                industry_id: industryId
            };
            const res = await fetch(`${apiUrl}/admin/viewindustry`,{
                method:'POST',
                headers:{
                    "Content-Type":"application/json",
                    "Accept":"application/json"
                },
                body:JSON.stringify(postData)
            });
            const data = await res.json();
            if(data.status !== 200){
              throw new Error('Data not found');
            }
            setItems(data.data);
          }catch(error){
            console.error('Error ', error)
          }
        };
        getComments();
      }, []);
      let catname = '';
      let subcatname = '';
      if(items.categoryname === ""){
        catname = 'No category found.';
      }
      else{
        catname = items.categoryname;
      }
      if(items.subcategoryname === ""){
        subcatname = 'No subcategory found.';
      }
      else{
        subcatname = items.subcategoryname;
      }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>View Industry</h2>
            <div className='commonCntr'>
                <form className="form-horizontal" action="">
                <div className="form-group">
                        <label className="control-label col-sm-2 label">Industry Name:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{items.industryname}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Category Name:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{catname}</span>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label">Subcategory Name:</label>
                        <div className="col-sm-10 mt-1">
                            <span>{subcatname}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default Industryview; 